import notify from 'src/utilities/notify';

const cleanConfirmationMessage = (confirmationMessage: string) : string => {
	const parser = new DOMParser();

	// Parse the HTML string to remove html tags
	const doc = parser.parseFromString(confirmationMessage, 'text/html');

	// Remove content in brackets
	doc.querySelectorAll('*').forEach(element => {
		element.childNodes.forEach(childNode => {
			childNode.textContent = childNode.textContent.replace(/\[.*?\]/g, '');
		});
	});

	// Replace \n with <br>
	const textContent = doc.body.textContent.replace(/\n/g, '<br>');

	return textContent;
};

export const showConfirmationMessage = (confirmationMessage: string) => {
	notify(cleanConfirmationMessage(confirmationMessage), 'success');
};